
import { Search } from 'vant'
import { getTime, transform } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';
// 方法一，加载顺序有问题
// import AMap from 'AMap' // 引入高德地图
// 方法二
import {AMap} from '../../../assets/libs/loadjs';

export default {
  name: 'home',
  components: {
    [Search.name]: Search
  },
  data () {
    return {
      mapCenter: [104.065755, 30.657555],
      mapZoom: 16,
      mapIcon: require('../../../assets/images/map/ic_redcar.png'),
      mapIconLy: require('../../../assets/images/map/ic_redcar_ly.png'),
      mapAngle: 0,
      devImei: '',
      devAddress: '加载中...',
      devPosition: '加载中...',
      devSpeed: 0,
      devTime: '',
      // 2和7状态下的监控时间
      monitorTime: '',
      // devOnline表示设备是否在线
      devOnline: false,
      // devStatus表示设备的状态,如:在线,离线,关机等
      devStatus: 0,
      devAccuracy: 1,
      devPositionType: 'GPS定位',
      // 20200523 add
      devPositionTypeNum: null,
      // 定时更新车辆位置
      setIntervalCarInfo: null,
      intervalTime: 10000,
      // 检查显示地址的节点是否加载
      checkAddressTextTimes: 0,
      setIntervalCheckAddressText: null
    }
  },
  methods: {
    // 初始化,获取设备当前位置信息
    initCarInfoFn (getType) {
      if (getType === 'init') {
        this.$toast.loading({
          overlay: true,
          duration: 0,
          message: '正在加载...'
        });
      }
      this.$axios.post('/v3/u/vehicle/realTimeInfo')
        .then(response=>{
          // console.log(response);
          if (getType === 'init') {
            this.$toast.clear();
          }
          if (response.data.ret === 0) {
            // 保存信息
            const lon = response.data.data.gps_data.lon||116.403963;
            const lat = response.data.data.gps_data.lat||39.915119
            let mapCenterBefore = this.mapCenter;
            let devStatusBefore = this.devStatus;
            this.mapCenter = [lon, lat];
            this.devImei =  this.$cookies.get('imei');
            this.devSpeed = response.data.data.gps_data.speed;
            this.devTime = getTime.getFormatDate(2, response.data.data.gps_data.time);
            this.devOnline = response.data.data.is_online;
            this.devStatus = response.data.data.status;
            this.devAccuracy = response.data.data.accuracy;
            this.devPositionType = response.data.data.position_type === 1 ? 'GPS定位' : response.data.data.position_type === 2 ? '未定位' : '未知';
            this.devPositionTypeNum = response.data.data.position_type;
            this.mapAngle = response.data.data.gps_data.direct;
            if (response.data.data.status === 2 || response.data.data.status === 7) {
              this.monitorTime = getTime.getPassedTime(response.data.data.statusChangeTime);
            }
            // 加载地图
            if (getType === 'init') {
              this.initMap('all')
            }else {
              this.showNowTime();
            }
          } else {
            clearInterval(this.setIntervalCarInfo);
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取位置信息失败（' + response.data.ret + '）'
            })
          }
        })
        .catch((error)=>{
          // this.$toast.clear();
          errorModal(error, 111);
        })
    },
    // 初始化地图,showType参数为init只加载一个默认地图,不加载图标和窗口
    initMap (showType) {
      let map = new AMap.Map('container', {
        center: this.mapCenter,
        resizeEnable: true,
        zoom: this.mapZoom
      });
      if (showType === 'init') {
        return
      }
      // 创建一个 Marker 实例：
      var icon = (this.devStatus === 2 || this.devStatus === 7) ? this.mapIconLy : this.mapIcon;
      var offset = (this.devStatus === 2 || this.devStatus === 7) ? new AMap.Pixel(-50, -50) : new AMap.Pixel(-17, -30);
      let marker = new AMap.Marker({
        position: new AMap.LngLat(this.mapCenter[0], this.mapCenter[1]),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: '点击查看详情',
        offset: offset, // new AMap.Pixel(-15, -30)
        icon: icon, // 图标不能通过相对路径直接引入,可以通过require()引入或者使用网络url
        angle: this.mapAngle
      });
      // 将创建的点标记添加到已有的地图实例：
      map.add(marker);

      // 折线的节点坐标数组，每个元素为 AMap.LngLat 对象
      let title = '设备：<span style="color: #007aff;">' + this.devImei || $cookies.get('imei') + '</span>';
      // devStatus
      let devStatusText = '设备异常';
      let devStatusColor = '#ff0000';
      if (this.devStatus === 1) {
        devStatusText = '点火在线';
        devStatusColor = '#07c160';
      } else if (this.devStatus === 2) {
        // 熄火在线状态就是停车监控状态
        devStatusText = '停车监控';
        devStatusColor = '#07c160';
      } else if (this.devStatus === 3) {
        devStatusText = '关机';
      } else if (this.devStatus === 4) {
        devStatusText = '熄火离线';
      } else if (this.devStatus === 5) {
        devStatusText = '离线（异常）';
      } else if (this.devStatus === 6) {
        devStatusText = '低电关机';
      } else if (this.devStatus === 7) {
        devStatusText = '缩时录影';
        devStatusColor = '#07c160';
      } else if (this.devStatus === 8) {
        devStatusText = '超时关机';
      }
      let content = [
        '<div style="background-color: #ffffff;padding-top: 5px;border-radius: 5px;color: #333333;">' +
        '<p style="padding: 1px 0;line-height: 1.2rem;">地址：<span id="address-text">' + this.devAddress + '</span><span id="dev-accuracy"></span></p>' +
        '<p style="padding: 1px 0;line-height: 1.2rem;">定位：<span id="address-type">' + this.devPosition + '</span></span></p>' +
        '<p style="padding: 1px 0;line-height: 1.2rem;">速度：' + (parseInt(this.devSpeed) < 10 ? 0 : parseInt(this.devSpeed)) + '公里/小时</p>' +
        '<p style="padding: 1px 0;line-height: 1.2rem;">时间：<span id="time-text">' + (this.devTime || '') + '</span></p>' +
        '<p style="padding: 1px 0;line-height: 1.2rem;">状态：<span style="color: ' + devStatusColor + '">' + (devStatusText || 0) + '</span></p>' +
        '</div>'
      ];
      if (this.devStatus === 2) {
        // 2和7的情况下显示时间
        content = [
          '<div style="background-color: #ffffff;padding-top: 5px;border-radius: 5px;color: #333333;">' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">地址：<span id="address-text">' + this.devAddress + '</span><span id="dev-accuracy"></span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">时间：<span id="time-text">' + (this.devTime || '') + '</span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">状态：<span style="color: ' + devStatusColor + '">' + (devStatusText || 0) + '</span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">已监控：<span id="monitor-text">' + (this.monitorTime || '小于1分钟') + '</span></p>' +
          '</div>'
        ];
      } else if (this.devStatus === 7) {
        // 缩时录影状态下可退出
        content = [
          '<div style="background-color: #ffffff;padding-top: 5px;border-radius: 5px;color: #333333;">' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">地址：<span id="address-text">' + this.devAddress + '</span><span id="dev-accuracy"></span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">时间：<span id="time-text">' + (this.devTime || '') + '</span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">状态：<span style="color: ' + devStatusColor + '">' + (devStatusText || 0) + '</span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">已录像：<span id="monitor-text">' + (this.monitorTime || '小于1分钟') + '</span></p>' +
          '<div style="width: 100%;"><label id="reserveBtn" style="display: inline-block;width: 101%;margin: 8px 0 3px 1%;padding:8px 0;text-align: center;background-color: #007aff;color: #ffffff;border-radius: 4px;">退出缩时录影模式</label></div>' +
          '</div>'
        ];
      } else if (!(this.devStatus === 1 || this.devStatus === 2)) {
        // 离线的情况下不显示定位和速度
        content = [
          '<div style="background-color: #ffffff;padding-top: 5px;border-radius: 5px;color: #333333;">' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">地址：<span id="address-text">' + this.devAddress + '</span><span id="dev-accuracy"></span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">时间：<span id="time-text">' + (this.devTime || '') + '</span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">状态：<span style="color: ' + devStatusColor + '">' + (devStatusText || 0) + '</span></p>' +
          '</div>'
        ];
      } else if (this.devPositionTypeNum === 2) {
        // 定位方式是网络定位时不显示速度
        content = [
          '<div style="background-color: #ffffff;padding-top: 5px;border-radius: 5px;color: #333333;">' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">地址：<span id="address-text">' + this.devAddress + '</span><span id="dev-accuracy"></span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">定位：<span id="address-type">' + this.devPosition + '</span></span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">时间：<span id="time-text">' + (this.devTime || '') + '</span></p>' +
          '<p style="padding: 1px 0;line-height: 1.2rem;">状态：<span style="color: ' + devStatusColor + '">' + (devStatusText || 0) + '</span></p>' +
          '</div>'
        ];
      }
      // 通过事件委托解决点击事件
      let fatherDiv = document.getElementById('container');
      fatherDiv.onclick = function (e) {
        // 判断事件源是不是reserveBtn
        if (e.target.id.toLowerCase() === 'reserveBtn') {
          _this.exitVideoRecordingFn();
        }
        if (e.target.id.toLowerCase() === 'dev-accuracy') {
          transform.pointToAddress(_this.mapCenter[0], _this.mapCenter[1], 1, function (res) {
            _this.checkAddressTextFn(res);
          });
        }
      };
      // 实现自定义窗体内容，返回拼接后的字符串
      function createInfoWindow (title, content) {
        // 内容拼接 ...
        return title + content;
      }
      // 创建 infoWindow 实例
      var offsetWindow = (this.devStatus === 2 || this.devStatus === 7) ? new AMap.Pixel(0, -50) : new AMap.Pixel(0, -30);
      let infoWindow = new AMap.InfoWindow({
        isCustom: false,  // 是否使用自定义窗体
        anchor: 'bottom-center', // 默认值：'bottom-center'
        content: createInfoWindow(title, content.join('<br>')),  // 传入dom对象，或者html字符串
        offset: offsetWindow, // 信息窗体显示位置偏移量
        closeWhenClickMap: true, // 是否在鼠标点击地图后关闭信息窗体，默认false
        showShadow: false, // 是否显示信息窗体阴影默认值：false
        // size: ''
      });
      // 信息窗体打开
      infoWindow.open(map, this.mapCenter);
      // 信息窗体关闭
      // infoWindow.close();

      // 监听地图的点击事件
      AMap.event.addListener(map, 'click', function () {
        infoWindow.open(map, this.mapCenter);
      });
      // 监听点标记的点击事件
      AMap.event.addListener(marker, 'click', function () {
        infoWindow.open(map, this.mapCenter);
      });

      // 解析地址
      let _this = this;
      transform.pointToAddress(_this.mapCenter[0], _this.mapCenter[1], 1, function (res) {
        _this.checkAddressTextFn(res);
      });
    },
    // 判断显示地址信息的节点是否加载
    checkAddressTextFn (res) {
      let addressTextNode = document.querySelector('#address-text');
      if (this.checkAddressTextTimes < 10) {
        if (addressTextNode) {
          clearInterval(this.setIntervalCheckAddressText);
          this.showAddressFn(res);
        } else {
          let _this = this;
          let setIntervalCheckAddressText = setInterval(function () {
            _this.checkAddressTextTimes++;
            _this.checkAddressTextFn(res);
          }, 1000);
          this.setIntervalCheckAddressText = setIntervalCheckAddressText;
        }
      } else {
        clearInterval(this.setIntervalCheckAddressText);
        this.showAddressFn(res);
      }
    },
    // 将解析出的地址信息显示到页面(用定时器是因为偶尔会出现document.querySelector('#address-text')为null的情况,引起报错)
    showAddressFn (res) {
      let _this = this;
      if (res.code === 0) {
        // 根据坐标点解析出地址信息后显示到页面
        let addressText = document.querySelector('#address-text');
        addressText.innerHTML = res.address;
        _this.devAddress = res.address;
        if (_this.devStatus === 1) {
          let addressType = document.querySelector('#address-type');
          let devPosition = (_this.devAccuracy && _this.devPositionType !== '网络定位') ? (_this.devPositionType + ', 定位精度' + _this.devAccuracy + '米') : _this.devPositionType;
          addressType.innerHTML = devPosition;
          _this.devPosition = devPosition;
        }
      } else {
        let addressText = document.querySelector('#address-text');
        addressText.innerHTML = '暂无地址信息';
        _this.devAddress = '暂无地址信息';
        if (_this.devStatus === 1) {
          let addressType = document.querySelector('#address-type');
          addressType.innerHTML = '暂无定位信息';
          _this.devPosition = '暂无定位信息';
        }
      }
    },
    // 地图放大缩小
    changeMapZoomFn (tpye) {
      if (tpye === 1 && this.mapZoom > 3) {
        this.mapZoom--;
      } else if (tpye === 2 && this.mapZoom < 19) {
        this.mapZoom++;
      }
    },
    // InfoWindow弹框 控制
    infoWindowClose () {
      this.showInfoWindow = false;
    },
    infoWindowOpen () {
      this.showInfoWindow = true;
    },
    // 单独更新时间(在地图位置没有改变的情况下,避免地图发送抖动,地图不会重新加载,只更新时间)
    showNowTime () {
      let timeText = document.querySelector('#time-text');
      // timeText.innerHTML = this.devTime;
      // if (this.devStatus === 2 || this.devStatus === 7) {
      //   let monitorText = document.querySelector('#monitor-text');
      //   monitorText.innerHTML = this.monitorTime || '小于1分钟';
      // }
    },
    // 退出缩时录影模式
    exitVideoRecordingFn () {
      let _this = this;
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '操作中...'
      });
      this.$axios.post('/action/parkToSecurity', {})
        .then(function (response) {
          _this.$toast.clear();
          if (response.data.ret === 0) {
            // 关闭加载状态
            _this.$dialog({
              message: '已退出缩时录影'
            });
            _this.checkAddressTextTimes = 0;
            _this.initCarInfoFn();
          } else {
            _this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '操作失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 112);
        })
    }
  },
  mounted () {
    // console.error('AMapPos',AMap, Date.now());
    // 地图不能在 created 阶段调用，会找不到 html 元素 div#container
    document.getElementById('container').style.height = window.screen.height;
    this.initCarInfoFn('init');
    // 每10秒更新一次地图数据
    let _this = this;
    let setIntervalCarInfo = setInterval(function () {
      _this.initCarInfoFn();
    }, this.intervalTime);
    this.setIntervalCarInfo = setIntervalCarInfo;
  },
  destroyed () {
    clearInterval(this.setIntervalCarInfo)
  }
}
